import React, { useState } from 'react';

import {Items, useFetch} from '@thinkwell/react.common';
const ProductsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const ProductsProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))
  const [fetchProductsState, fetchProducts] = useFetch({onSuccess: setItems})

  return (
    <ProductsContext.Provider value={[items, fetchProducts, fetchProductsState, upsertItem, getItem, deleteItem]}>
      {props.children}
    </ProductsContext.Provider>
  );
};

export { ProductsContext, ProductsProvider}
